module.exports = __webpack_public_path__ + "static/media/word-document.51554742.svg";